var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('wysiwyg',{attrs:{"placeholder":"Digite aqui o texto"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_vm._v(" "),_c('textarea',{staticStyle:{"display":"none"},attrs:{"name":"input_message","required":_vm.required},domProps:{"value":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }